import ConnectedCategoryCard from "./ConnectedCategoryCard";
import ConnectedRegistrationPage from "./ConnectedRegistrationPage";
import ConnectedRegistrationPageContent from "./ConnectedRegistrationPageContent";

export { ConnectedCategoryCard, ConnectedRegistrationPageContent };
export default ConnectedRegistrationPage;
